import { getAdMarketPublishGroupCode, getMarketCountryCode } from './sharedAdsUtils';
// Country codes:
// https://msdn.microsoft.com/en-us/library/ms707477(v=vs.85).aspx
//
// EU member countries:
// https://europa.eu/european-union/about-eu/countries_en
//
var gdprMarkets = [
    'AT',
    'BE',
    'BG',
    'CY',
    'DE',
    'DK',
    'EE',
    'ES',
    'EZ',
    'FI',
    'FR',
    'GB',
    'GR',
    'HR',
    'HU',
    'IL',
    'IT',
    'LT',
    'LU',
    'LV',
    'MT',
    'NL',
    'PL',
    'PT',
    'RO',
    'SE',
    'SI',
    'SK',
];
export default function isGdprAdMarket() {
    var countryCode = getMarketCountryCode(getAdMarketPublishGroupCode());
    return gdprMarkets.indexOf(countryCode) >= 0;
}
//# sourceMappingURL=isGdprAdMarket.js.map